{% block sw_cms_element_image_slider %}
    <div
            class="sw-cms-el-acris-blog-image-slider"
            :class="outsideNavArrows"
            :style="verticalAlignStyle"
    >
        {% block sw_cms_element_image_slider_img %}
            <div
                    class="sw-cms-el-acris-blog-image-slider__image-box"
                    :class="[displayModeClass, navDotsClass]"
                    :style="styles"
            >
                <img
                        class="sw-cms-el-acris-blog-image-slider__image"
                        :src="imgSrc"
                        alt=""
                >
            </div>
        {% endblock %}

        {% block sw_cms_element_image_slider_nav_default %}
            <div class="sw-cms-el-acris-blog-image-slider__navigation">
                <div class="sw-cms-el-acris-blog-image-slider__navigation-arrows is--nav-outside">
                    <mt-icon
                            class="sw-cms-el-acris-blog-image-slider__navigation-button"
                            name="regular-chevron-left"
                            size="24"
                    />
                    <mt-icon
                            class="sw-cms-el-acris-blog-image-slider__navigation-button"
                            name="regular-chevron-right"
                            size="24"
                    />
                </div>
            </div>
        {% endblock %}
    </div>
{% endblock %}
